import { render, staticRenderFns } from "./PageAccessMain.vue?vue&type=template&id=7da61a26&scoped=true&"
import script from "./PageAccessMain.vue?vue&type=script&lang=js&"
export * from "./PageAccessMain.vue?vue&type=script&lang=js&"
import style0 from "./PageAccessMain.vue?vue&type=style&index=0&id=7da61a26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da61a26",
  null
  
)

export default component.exports